import groupBy from 'lodash/groupBy';
import omit from 'lodash/omit';
import { mapArticleTypeToTitle } from '@/finsight/ui/components/creditFlow/articles/constants';
import { IMarketTheme } from '@/finsight/domain/vo/CreditFlow/IMarketTheme';
import { ITheme } from '@/finsight/domain/vo/CreditFlow/Article';
import { ThemeType } from '@/finsight/domain/vo/CreditFlow/Articles/themeTypes';
import { ISubscriptionsPayloadTheme } from '@/finsight/domain/vo/Subscriptions';

export const getGroupedThemesIds = (groupedThemes: Record<string, ITheme[]>) => Object.entries(groupedThemes).reduce(
    (acc, [type, themes]) => ({ ...acc, [type]: themes.map((theme) => theme.id) }), {},
);

export const getThemesChildren = (themes: ITheme[]) => themes.map((theme) => ({
  value: theme.id,
  label: theme.themeName,
  disabled: false,
}));

const getInitialThemes = (
    ids: string[] = [],
    themesSubscriptionsIds: string[],
) => ids.filter((id) => themesSubscriptionsIds.includes(id));

export const getInitialThemesState = (
    themesIds: Record<typeof mapArticleTypeToTitle[ThemeType], string[]>,
    themesSubscriptionsIds: string[],
) => ({
  [ThemeType.dealFlow]:
    getInitialThemes(themesIds[mapArticleTypeToTitle[ThemeType.dealFlow]], themesSubscriptionsIds) || [],
  [ThemeType.commentary]:
    getInitialThemes(themesIds[mapArticleTypeToTitle[ThemeType.commentary]], themesSubscriptionsIds) || [],
  includeAllType: [],
});

export const getThemesByThemeId = (
  values: Omit<typeof getInitialThemesState, 'includeAllType'>,
  groupedThemesById: Record<typeof mapArticleTypeToTitle[ThemeType], IMarketTheme[]>,
): ISubscriptionsPayloadTheme[] => {
  return Object.values(values)
      .flat().map((themeId: string) => ({
    themeId: groupedThemesById[themeId][0].id,
    productId: groupedThemesById[themeId][0].productId,
    regionId: groupedThemesById[themeId][0].regionId,
  }));
};

export const getSubscribeThemesWithValues = (values: ReturnType<typeof getInitialThemesState>, {
  themes,
  themesSubscriptions,
  currentRegionId,
  currentProductId,
}: {
  themes: IMarketTheme[],
  themesSubscriptions: ISubscriptionsPayloadTheme[],
  currentRegionId: string,
  currentProductId: string,
}): ISubscriptionsPayloadTheme[] => {
  const groupedThemesById = groupBy(themes, 'id');
  const formThemes = getThemesByThemeId(omit(values, 'includeAllType'), groupedThemesById);
  const themesToMerge = themesSubscriptions.filter(
      ({ regionId, productId }) => regionId !== currentRegionId || productId !== currentProductId,
  );

  return [...formThemes, ...themesToMerge];
};
